/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./copy-creative.vue?vue&type=template&id=37c9b9c3&scoped=true&"
import script from "./copy-creative.vue?vue&type=script&lang=js&"
export * from "./copy-creative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9b9c3",
  null
  
)

export default component.exports